module.exports = __webpack_public_path__ + "static/img/wxzhifu.bf65d5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/wxzhifu.png
// module id = tD5w
// module chunks = 1